export default __webpack_public_path__ + "static/media/hippo_mark.cb54636e.png";